import {
  EditOutlined,
  ExpandMore as ExpandMoreIcon,
} from "@mui/icons-material";
import { Box, Collapse, IconButton, Tooltip } from "@mui/material";
import { grey } from "@mui/material/colors";
import { memo, useMemo, useState } from "react";
import Flx from "../../layout/Flx";
import Txt from "../../typography/Txt";
import SidebarSectionTitle from "./SidebarSectionTitle";
import { isEmpty } from "lodash";

const SidebarSection = memo(
  ({
    title,
    children,
    defaultOpen = true,
    onEdit,
    visibleCount,
    disableCollapse = false,
    subsection = false,
    subTitle,
    underlinePosition = "bottom", // 'bottom' or 'title' or 'body
    variant = "default", //
    totalCount,
    hideBorder = false,
    // hideBorder = true,
    heavyDivider = false,
    headerEndContent,
    bodySx,
    bodyPadding,
    sx,
  }) => {
    const [open, setOpen] = useState(defaultOpen);
    const border = hideBorder
      ? "none"
      : `${heavyDivider ? 2 : 1}px solid ${heavyDivider ? "f1f2f5" : grey[100]}`;
    const bodyStyles = useMemo(() => {
      if (!isEmpty(bodySx)) {
        return bodySx;
      }
      return {
        mb: underlinePosition === "body" ? 3 : 0,
        pt: underlinePosition === "body" ? 1.5 : 0,
        px: underlinePosition === "body" ? 2 : 0.8,
        pb: underlinePosition === "body" ? 1.5 : 3,
        border: underlinePosition === "body" ? border : "none",
        borderRadius: 2,
      };
    }, [bodySx, underlinePosition, border]);
    if (typeof visibleCount === "number" && visibleCount === 0) return null;

    const isFiltered =
      typeof visibleCount === "number" &&
      typeof totalCount === "number" &&
      visibleCount < totalCount;

    if (subsection) {
      return (
        <Flx column g={0} sx={sx}>
          <Box
            className="sidebar-section-header"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              // px: 0.5,
              // py: disableCollapse ? 0 : open ? 2 : 2,
              // pb: disableCollapse ? 0.5 : open ? 2 : 2,
              // cursor: disableCollapse ? "default" : "pointer",
              // userSelect: "none",
              // "&:hover": { bgcolor: disableCollapse ? "inherit" : grey[50] },
              // transition: "background-color 0.1s",
            }}
          >
            <Flx column g={0.5}>
              <Flx ac g={1}>
                <SidebarSectionTitle subSection>{title}</SidebarSectionTitle>
                {isFiltered && (
                  <Txt
                    sx={{ fontSize: 10, color: grey[400], fontStyle: "italic" }}
                  >
                    {visibleCount}/{totalCount}
                  </Txt>
                )}
              </Flx>
              {subTitle && (
                <Txt sx={{ fontSize: 11, color: grey[500] }}>{subTitle}</Txt>
              )}
            </Flx>
            {headerEndContent}
          </Box>
          <Box className="sidebar-section-body" sx={{ px: 0, ...bodySx }}>
            {children}
          </Box>
        </Flx>
      );
    }
    return (
      <Box
        sx={{
          // mb: hideBorder ? 0 : 3,
          borderBottom:
            underlinePosition === "bottom" && !open ? border : "none",
          ...sx,
        }}
      >
        <Box
          className="sidebar-section-header"
          onClick={() => !disableCollapse && setOpen(!open)}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 0.5,
            py: disableCollapse ? 0 : open ? 2 : 2,
            // py: 2,
            pb: disableCollapse ? 0.5 : open ? 1 : 2,
            cursor: disableCollapse ? "default" : "pointer",
            userSelect: "none",
            mb: underlinePosition === "title" && open ? 1 : 0,
            borderBottom:
              underlinePosition === "title" ||
              (underlinePosition === "body" && !open)
                ? border
                : "none",
            "&:hover": { bgcolor: disableCollapse ? "inherit" : grey[50] },
            transition: "background-color 0.1s",
          }}
        >
          <Flx column g={0.5}>
            <Flx ac g={1}>
              <SidebarSectionTitle>{title}</SidebarSectionTitle>
              {isFiltered && (
                <Txt
                  sx={{ fontSize: 10, color: grey[400], fontStyle: "italic" }}
                >
                  {visibleCount}/{totalCount}
                </Txt>
              )}
            </Flx>
            {subTitle && (
              <Txt sx={{ fontSize: 11, color: grey[500] }}>{subTitle}</Txt>
            )}
          </Flx>
          <Flx ac g={0.1}>
            {headerEndContent}
            {disableCollapse ? null : (
              <Flx ac g={0.1}>
                {onEdit && (
                  <Tooltip title={`Edit ${title}`} arrow>
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        onEdit();
                      }}
                      sx={{
                        p: 0.5,
                        opacity: 0.5,
                        "&:hover": { opacity: 1 },
                      }}
                    >
                      <EditOutlined sx={{ fontSize: 14 }} />
                    </IconButton>
                  </Tooltip>
                )}

                <ExpandMoreIcon
                  sx={{
                    fontSize: 18,
                    color: "rgb(148, 163, 184)",
                    transition: "transform 0.2s",
                    transform: open ? "rotate(0deg)" : "rotate(-90deg)",
                  }}
                />
              </Flx>
            )}
          </Flx>
        </Box>

        <Collapse in={open}>
          <Box className="sidebar-section-body" sx={bodyStyles}>
            {children}
          </Box>
        </Collapse>
      </Box>
    );
  },
);

SidebarSection.displayName = "SidebarSection";

export default SidebarSection;
